import ContractEquipmentsFilter from "./ContractEquipmentsFilter";

export default ContractEquipmentsFilter;
